import React from "react";
import { ArrowRight, FileText } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "./ui/dialog";

const inclusions = [
  { text: "Consulate fees" },
  { text: "Medical insurance (Covers Coronavirus)" },
  { text: "Service charges" },
  { text: "All taxes" },
];

export function VisaInclusions() {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold mb-4">Dubai Visa Price includes:</h2>
        <ul className="space-y-2">
          {inclusions.map((item, index) => (
            <li key={index} className="flex items-center">
              <ArrowRight size={16} className="text-primary mr-3" />
              <span>{item.text}</span>
            </li>
          ))}
        </ul>
      </div>

      <p className="text-muted-foreground">
        Depending on your planned type of visit to Dubai and duration of your
        stay, you can select from 48 hrs Visa, 30 days Visa (short stay) or 90
        days Visa (long stay) both single & multiple. We are one of the premier
        companies of UAE visa services providers at the cheapest rate with the
        least requisites.
      </p>

      <Dialog>
        <DialogTrigger asChild>
<div className="flex items-center justify-between p-6 rounded-lg text-white bg-[#e71875] hover:shadow-lg transition-shadow cursor-pointer">
            <div className="flex items-center">
              <FileText size={40} className="mr-4" />
              <span className=" text-2xl font-bold">View sample visa copy</span>
            </div>
            <ArrowRight size={32} />
          </div>
        </DialogTrigger>

        <DialogContent className="p-0 h-[80vh] w-[80vw] sm:w-[50vw]">
          <DialogTitle className="sr-only">Sample Dubai Visa</DialogTitle>
          <div className="relative w-full h-full flex items-center justify-center bg-black">
            <img
              src="/global/dubai-sample.jpg"
              alt="Sample Dubai Visa"
              className="object-contain max-h-full max-w-full"
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
